(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const narrow = matchMedia('(max-width: 900px)');
  let visuals = [];
  let frame = 0;
  function update() {
    frame = 0;
    visuals.forEach(node => {
      const box = node.getBoundingClientRect();
      const drift = reduced.matches || narrow.matches ? 0 : Math.max(-10, Math.min(10, (innerHeight / 2 - box.top - box.height / 2) * .025));
      node.style.setProperty('--lf-art-drift', `${drift.toFixed(1)}px`);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function bind() {
    visuals = [...document.querySelectorAll('.lf-design-hero .lf-support-photo, .lf-design-hero.lf-catalog-hero figure, .lf-layered-art, .lf-design-hero .lf-education-photo')];
    schedule();
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', bind);
  bind();
})();